import {xy, xyz} from "./canvasTypes";

export function convert3dTo2d  ([x,y,z]:xyz):xy {
    // todo figure out rotate and distort
    // note reference
    // https://amycoders.org/tutorials/3dbasics.html
    let zOff = 500; // viewport offset to make math happen
    let sideOff = 0; // offset to pull shape away from edge
    let dostuff = 180; // seems to be able to rotate but also has a little distort
    // Notes:
    // https://amycoders.org/tutorials/3dbasics.html
    // [x*zOff/(z+zOff), y*zOff/(z+zOff)]
    return [(((x+dostuff)*zOff)/(z+zOff+dostuff))+sideOff,(((y+dostuff)*zOff)/(z+zOff+dostuff))+sideOff]
}
